/**
 * True when the app is running from the home screen rather than a browser tab.
 *
 * iOS Safari exposes `navigator.standalone`; everything else reports the
 * display mode the manifest asked for.
 */
export default function isStandalone(): boolean {
  const iosStandalone = (
    window.navigator as Navigator & { standalone?: boolean }
  ).standalone;

  return (
    iosStandalone === true ||
    window.matchMedia('(display-mode: standalone)').matches
  );
}
